export default function nowPlayingMetadata(metadata) {
  let mediaSession = {
    artist: undefined,
    title: undefined,
    album: undefined,
    artwork: undefined,
  };

  let imageSource = metadata.imageSource;
  mediaSession.artwork = imageSource ? [
    imageSource.small_square?.url && { src: imageSource.small_square.url, sizes: '250x250' },
    imageSource.medium_square?.url && { src: imageSource.medium_square.url, sizes: '500x500' },
    imageSource.large_square?.url && { src: imageSource.large_square.url, sizes: '1500x1500' },
  ].filter(Boolean) : [{ src: undefined }];

  if (metadata.itemType === 'track') {
    mediaSession.artist = metadata.track?.artistName;
    mediaSession.title = metadata.track?.title;
    mediaSession.album = metadata.track?.releaseName;
  } else if (metadata.itemType === 'note') {
    mediaSession.title = metadata.show?.title;
  } else if (metadata.show) {
    mediaSession.title = metadata.show?.title;
  } else if (metadata.station) {
    mediaSession.title = metadata.station?.callSign
  }

  return mediaSession;
}
